import { render, staticRenderFns } from "./AttachFileOut.vue?vue&type=template&id=33653963&scoped=true"
import script from "./AttachFileOut.vue?vue&type=script&lang=js"
export * from "./AttachFileOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33653963",
  null
  
)

export default component.exports